import React from 'react';
import Button from '@mui/material/Button';
import { Grid, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import InputForm from '../../commun/input-form';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import './composition.form.scss';
import { LocalAuthorityDto } from '../../../services/dtos/local-authority.dto';

/**
 * Compsant qui permet de rechercher les collectivités rattachées
 * @constructor
 * @param props
 */
export default function LocalAuthorityForm(
    props: Readonly<{
        handlerSearch: (e: LocalAuthorityDto) => void;
        searching: boolean;
    }>
) {
    //Initialisation des valeurs
    const iniValues: LocalAuthorityDto = {
        authority: '',
        establishment: '',
        naming: '',
        membershipDate: '',
    };

    return (
        //Retourne la vue
        <Formik
            initialValues={iniValues}
            onReset={props.handlerSearch}
            onSubmit={props.handlerSearch}
            className="form-composition"
        >
            <Form>
                <Grid container spacing={2} sx={{ marginTop: '10px' }}>
                    <Grid item xs={12} md={4}>
                        <InputForm autoFocus id="naming" name="naming" label="Désignation" />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <InputForm
                            autoFocus
                            id="membershipDate"
                            name="membershipDate"
                            label="Date d’adhésion"
                            type="date"
                        />
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {/*Gestion des boutons*/}
                        <Typography variant={'button'} className={'buttons-form'}>
                            <Button variant="neutral" type="reset">
                                <ClearIcon />
                            </Button>
                            {/*Bouton valider, désactivé durant le traitement du formulaire*/}
                            <Button
                                data-testid={'search-local-authority'}
                                type="submit"
                                variant="contained"
                                sx={{ marginLeft: '10px' }}
                                disabled={props.searching}
                            >
                                <SearchIcon />
                            </Button>
                        </Typography>
                    </Grid>
                </Grid>
            </Form>
        </Formik>
    );
}
